import { createSlice } from "@reduxjs/toolkit";
import { getReceptions, getUserData } from "./thunk";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  receptions: [],
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
  },
  extraReducers: (builder) => {
    // ✅ GET USER DATA
    builder
      .addCase(getUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserData.fulfilled, (state, action) => {
        state.loading = false;
        const rawUser =
          action.payload?.data?.data ||
          action.payload?.data?.user ||
          action.payload?.data ||
          action.payload?.user ||
          action.payload;

        if (rawUser && typeof rawUser === "object" && !Array.isArray(rawUser)) {
          const updatedUser = { ...state.user, ...rawUser };
          state.user = updatedUser;
          localStorage.setItem("user", JSON.stringify(updatedUser));
        }
      })
      .addCase(getUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // ✅ GET RECEPTIONS
    builder
      .addCase(getReceptions.pending, (state) => {
        state.loading = true;
        state.receptions = [];
        state.error = null;
      })
      .addCase(getReceptions.fulfilled, (state, action) => {
        state.loading = false;
        state.receptions = action.payload?.data;
      })
      .addCase(getReceptions.rejected, (state, action) => {
        state.loading = false;
        state.receptions = [];
        state.error = action.error.message;
      });
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;